// OCPP Templates translations for React Admin resource
export const ocppTemplatesResource = {
  name: 'OCPP Templates',
  fields: {
    id: 'ID',
    templateName: 'Template Name',
    description: 'Description',
    ocppVersion: 'OCPP Version',
    ocppProtocol: 'OCPP Protocol',
    normalIntervalSeconds: 'Normal Interval (seconds)',
    initialFastIntervalEnabled: 'Initial Fast Interval',
    initialFastIntervalSeconds: 'Initial Interval (seconds)',
    initialFastIntervalCount: 'Initial Reading Count',
    approachingIntervalEnabled: 'Enable Approaching Interval',
    approachingThresholdSeconds: 'Approaching Threshold (seconds)',
    approachingIntervalSeconds: 'Approaching Interval (seconds)',
    nearIntervalEnabled: 'Enable Near Interval',
    nearThresholdSeconds: 'Near Threshold (seconds)',
    nearIntervalSeconds: 'Near Interval (seconds)',
    hysteresisEnabled: 'Enable Hysteresis',
    hysteresisPercentage: 'Hysteresis (%)',
    hysteresisMinutes: 'Hysteresis (minutes)',
    powerSmoothingEnabled: 'Power Smoothing',
    powerSmoothingMethod: 'Smoothing Method',
    powerSmoothingFactor: 'Power Smoothing Factor',
    isActive: 'Active',
    isDefault: 'Default Template',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createdBy: 'Created By',
    usage: 'Usage',
    chargerCount: 'Assigned Chargers',
  },
};

// Custom OCPP templates translations for components
export const ocppTemplates = {
  show: {
    title: 'OCPP Template Details',
    subtitle: 'View and manage OCPP meter value interval configuration',
  },
  defaultTemplate: 'Default Template',
  create: {
    title: 'Create OCPP Template',
    subtitle: 'Define a new template for dynamic meter value intervals',
    backToList: 'Back to OCPP Templates',
  },
  edit: {
    title: 'Edit %{name}',
    subtitle: 'Modify the meter value interval settings and configuration',
    backToList: 'Back to OCPP Templates',
  },
  tabs: {
    general: 'General Information',
    intervals: 'Interval Configuration',
    advanced: 'Advanced Settings',
    danger: 'Danger Zone',
  },
  defaultTemplateNote: 'This is the default template used for new chargers',
  notInUse: 'This template is not currently assigned to any chargers',
  chargers: 'charger |||| chargers',
  charger: 'charger',
  chargersPlural: 'chargers',
  chargersUsing: 'Chargers Using This Template',
  affectedChargers: 'Affected Chargers',
  ocppVersions: {
    '1.6': 'OCPP 1.6',
    '2.0.1': 'OCPP 2.0.1',
  },
  ocppProtocols: {
    json: 'JSON',
    soap: 'SOAP',
  },
  smoothingMethods: {
    weighted_average: 'Weighted Average',
    moving_average: 'Moving Average',
    none: 'None',
  },
  configuration: 'Configuration',
  configExplanation: 'Normal interval: %{normal}s, Approaching: %{approaching}s when < %{approachingThreshold}s, Near: %{near}s when < %{nearThreshold}s',
  filters: {
    search: 'Search by name or description',
    activeOnly: 'Active Only',
    defaultOnly: 'Default Template',
    ocppVersion: 'OCPP Version',
  },
  actions: {
    assignToCharger: 'Assign to Charger',
    viewAssignedChargers: 'View Assigned Chargers',
    setAsDefault: 'Set as Default',
  },
  sections: {
    basic: 'Basic Information',
    intervals: 'Interval Configuration',
    advanced: 'Advanced Settings',
    thresholds: 'Dynamic Thresholds',
    powerSmoothing: 'Power Calculation',
    preview: 'Configuration Preview',
    usage: 'Usage Statistics',
    metadata: 'Metadata',
    dangerZone: 'Danger Zone',
  },
  helpers: {
    templateName: 'Unique name for this template',
    description: 'Optional description of the template purpose',
    ocppVersion: 'OCPP protocol version this template is designed for',
    normalIntervalSeconds: 'Default meter value reporting interval during normal charging',
    initialFastIntervalEnabled: 'Enable fast interval for initial readings to improve user experience',
    initialFastIntervalSeconds: 'Interval for the first few meter readings',
    initialFastIntervalCount: 'Number of initial readings at fast interval before switching to normal',
    approachingThresholdMinutes: 'Time remaining (in minutes) to trigger approaching interval',
    nearThresholdMinutes: 'Time remaining (in minutes) to trigger near interval',
    approachingIntervalSeconds: 'Meter value interval when approaching charging target',
    nearIntervalSeconds: 'Meter value interval when very close to charging target',
    hysteresisMinutes: 'Buffer time (in minutes) to prevent interval oscillation',
    powerSmoothingFactor: 'Smoothing factor (0-1) for power calculations, where 0 is no smoothing and 1 is maximum smoothing',
    powerSmoothingEnabled: 'Enable smoothing for stable power calculations',
    powerSmoothingMethod: 'Algorithm for smoothing power readings',
  },
  stats: {
    chargers: 'Chargers',
    chargersDesc: 'Total chargers using this template',
    totalPower: 'Total Power',
    totalPowerDesc: 'Total power capacity managed',
    normalInterval: 'Normal Interval',
    normalIntervalDesc: 'Default reporting interval',
  },
  normalInterval: 'Normal Interval',
  initialFastInterval: 'Initial Fast Interval',
  approachingInterval: 'Approaching Interval',
  nearInterval: 'Near Interval',
  intervalExplanation: 'Configure how frequently meter values are reported during different charging phases. More frequent intervals provide better real-time data but increase network traffic.',
  hysteresis: 'Hysteresis',
  hysteresisExplanation: 'Prevents rapid switching between intervals by adding a buffer zone. For example, with 20% hysteresis, the system will wait until the threshold is exceeded by 20% before switching intervals.',
  powerSmoothing: 'Power Smoothing',
  powerSmoothingExplanation: 'Applies weighted averaging to power readings to reduce fluctuations and provide more stable calculations. Higher values provide smoother readings but may reduce responsiveness.',
  inUseWarning: 'This template is currently assigned to chargers. Changes will affect their meter value reporting immediately.',
  defaultTemplateInfo: 'This is the default template. It will be automatically assigned to new chargers.',
  delete: {
    title: 'Delete OCPP Template',
    content: 'This template will be permanently deleted',
    hasChargersContent: 'Cannot delete template that is assigned to chargers',
    isDefault: 'Cannot delete the default template',
    warning: 'Warning: This action cannot be undone',
    confirmMessage: 'You are about to delete the OCPP template "%{name}"',
    typeToConfirm: 'To confirm deletion, please type "%{name}" below:',
    nameDoesNotMatch: 'Name does not match',
    button: 'Delete Template',
  },
  validation: {
    nameTooLong: 'Name must be less than 255 characters',
    descriptionTooLong: 'Description must be less than 500 characters',
    intervalTooLow: 'Interval must be at least %{min} seconds',
    intervalTooHigh: 'Interval cannot exceed %{max} seconds',
    thresholdTooLow: 'Threshold must be at least %{min} seconds',
    thresholdTooHigh: 'Threshold cannot exceed %{max} seconds',
    countTooLow: 'Count must be at least %{min}',
    countTooHigh: 'Count cannot exceed %{max}',
    hysteresisTooLow: 'Hysteresis must be at least %{min} minutes',
    hysteresisTooHigh: 'Hysteresis cannot exceed %{max} minutes',
    smoothingTooLow: 'Smoothing factor must be at least %{min}',
    smoothingTooHigh: 'Smoothing factor cannot exceed %{max}',
  },
  notifications: {
    created: 'OCPP template created successfully',
    updated: 'OCPP template updated successfully',
    deleted: 'OCPP template deleted successfully',
    deleteError: 'Failed to delete OCPP template',
    assigned: 'Template assigned to charger successfully',
    setAsDefault: 'Template set as default successfully',
  },
};